import React, { useEffect, useRef, useState } from "react";

import styled from "styled-components";
import { Colors } from "../config";
import { fetchNotificationList } from "../services/userServices";
import { useExtraFieldsContext } from "../contexts/ExtraFieldsContext";
import { useNavigate } from "react-router-dom";

const UserNotification = ({ src }) => {
  const [showList, setShowList] = useState(false);
  const [activeId, setActiveId] = useState(null);
  const [data, setData] = useState([]);
  const { extraFields, setExtraFields } = useExtraFieldsContext();
  const navigate = useNavigate();

  const handleItemClick = (id) => {
    navigate(`/user/bookings/status/${id}`);
  };

  const handleItemOpen = (e, id) => {
    e.stopPropagation();
    if (activeId === id) {
      setActiveId("");
    } else {
      setActiveId(id);
    }
  };

  const useOutsideAlerter = (ref) => {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setShowList(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  };

  useEffect(() => {
    if (showList) {
      notificationList();
    }
  }, [showList]);

  const notificationList = async () => {
    // let token = localStorage.getItem("firebaseEmployeeToken");
    const response = await fetchNotificationList();
    setData(response.data.data);
    setExtraFields((prev) => ({
      ...prev,
      newNotificationCount: 0,
    }));
    console.log("Notification list fetched successfully", response.data.data);
  };

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  const formatNotification = (value) => {
    const timestamp = value;
    const date = new Date(timestamp);

    const formattedDate = date.toLocaleDateString();

    const hours = date.getHours();
    const minutes = date.getMinutes();
    const period = hours >= 12 ? "PM" : "AM";

    const formattedTime = `${hours % 12 || 12}:${minutes
      .toString()
      .padStart(2, "0")} ${period}`;

    return (
      <DateTimeContainer>
        <div>{formattedDate}</div>
        <div>{formattedTime}</div>
      </DateTimeContainer>
    );
  };

  return (
    <NotificationContainer>
      <div>
        <NotificationButton onClick={() => setShowList(!showList)}>
          <NotificationImg src={src} alt="notification_logo" />
          {extraFields.newNotificationCount !== 0 && <NewNotification>{extraFields.newNotificationCount}</NewNotification>}
        </NotificationButton>
      </div>
      {showList && (
        <NotificationList ref={wrapperRef}>
          {data.length > 0 ? (
            data.map((notification) => (
              <StyledNotificationItem key={notification._id}>
                <StyledNotificationHeader
                  onClick={() =>
                    handleItemClick(notification?.additionalParams?.bookingId)
                  }
                >
                  <NotificatioTitleDateContainer>
                    <StyledNotificationTitle>
                      {notification.title}
                    </StyledNotificationTitle>
                    <StyledNotificationTime>
                      {formatNotification(notification.createdAt)}
                    </StyledNotificationTime>
                  </NotificatioTitleDateContainer>
                  <StyledNotificationIcon
                    onClick={(e) => handleItemOpen(e, notification._id)}
                    isOpen={activeId === notification._id}
                  >
                    {activeId === notification._id ? "▲" : "▼"}
                  </StyledNotificationIcon>
                </StyledNotificationHeader>
                {activeId === notification._id && (
                  <StyledNotificationBody>
                    {notification.body}
                  </StyledNotificationBody>
                )}
              </StyledNotificationItem>
            ))
          ) : (
            <NoNotificationsMessage>
              No Notifications available.
            </NoNotificationsMessage>
          )}
        </NotificationList>
      )}
    </NotificationContainer>
  );
};

const NotificationContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-end;
`;

const NotificatioTitleDateContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const DateTimeContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const NotificationButton = styled.button`
  border: 0px solid ${Colors.lightAshBlue};
  height: 3rem;
  width: 3rem;
  /* border-radius: 0.25rem; */
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background: transparent;
  /* background-color: ${Colors.brandOne}; */
`;
const NotificationImg = styled.img`
  @media only screen and (max-width: 768px) {
    width: 1.25rem;
  }
`;

const NewNotification = styled.div`
background: ${Colors.red};
height: 1.25rem;
width: 1.25rem;
border-radius: 1rem;
position: absolute;
top: -0.25rem;
right: -0.25rem;
color: white;
display: flex;
align-items: center;
justify-content: center;
`;

const NotificationList = styled.div`
  background: white !important;
  position: absolute;
  top: 3.5rem;
  width: 15rem;
  border: 2px solid ${Colors.blackPearl};
  border-radius: 0.25rem;
  padding: 0.5rem;
  z-index: 99;
  /* height: 20rem; */
  max-height: 20rem;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  &::-webkit-scrollbar {
    width: 0.875rem;
    -webkit-appearance: none;
  }
  &::-webkit-scrollbar-thumb {
    height: 3.625rem;
    border: 4px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 0.625rem;
    background-color: ${Colors.brandOne};
  }
`;

const StyledNotificationItem = styled.div`
  background-color: ${Colors.lightGray};
  padding: 0.625rem;
  border-bottom: 0.063rem solid ${Colors.silver};
`;

const StyledNotificationHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.313rem;
  cursor: pointer;
`;

const StyledNotificationTitle = styled.h4`
  margin: 0;
  font-size: 0.8rem;
`;

const StyledNotificationTime = styled.span`
  font-size: 0.75rem;
  color: ${Colors.spanishGray};
  display: flex;
  justify-content: flex-start;
`;

const StyledNotificationIcon = styled.span`
  font-size: 0.75rem;
  margin-left: 0.313rem;
  /* transform: ${(props) => (props.isOpen ? "rotate(180deg)" : "none")}; */
  transition: transform 0.2s ease-in-out;
`;

const StyledNotificationBody = styled.p`
  margin: 0;
  font-size: 0.875rem;
  line-height: 1.5;
`;
const NoNotificationsMessage = styled.div`
  padding: 0.625rem;
  text-align: center;
  font-size: 0.875rem;
  color: ${Colors.gray};
`;

export default UserNotification;
